import type {
  UpdateActionPayload,
  UpdateActionResponse,
} from '@/domains/academicRisk/academicRiskAction.entity';
import type { AcademicRiskActionRepository } from '@/domains/academicRisk/academicRiskAction.repository';

/**
 * Use Case para actualizar una acción académica existente
 *
 * Responsabilidades:
 * - Validar y ejecutar la actualización de acciones académicas
 * - Coordinar con el repositorio para persistir las modificaciones
 * - Permitir actualizar únicamente observaciones y acuerdos
 */
export class UpdateAcademicRiskActionUseCase {
  private repository: AcademicRiskActionRepository;

  constructor(repository: AcademicRiskActionRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la actualización de una acción académica
   * @param cod_incorporacion_accion código de la incorporación accion
   * @param payload - Datos de la acción a actualizar
   */
  async execute(
    cod_incorporacion_accion: number,
    payload: UpdateActionPayload,
  ): Promise<UpdateActionResponse> {
    return await this.repository.updateAction(
      cod_incorporacion_accion,
      payload,
    );
  }
}
